/* eslint-disable */
import classNames from 'classnames';
import CheckIcon from 'images/v5/icons/check.svg';
import React from 'react';
import { useParams } from 'react-router-dom';
import styles from './TabsWizard.module.scss';
const TabsWizard = ({ size = 'm', tabs, activeTab, onClick }) => {
    const params = useParams();
    const handleOnClick = (id) => {
        onClick(id);
    };
    const isActive = (id) => !!id && (id === activeTab || id === params.tab);
    return (React.createElement("div", { className: classNames(styles.wrap, styles[size]) }, tabs.map((tab, index) => {
        var _a;
        return (React.createElement(React.Fragment, { key: index },
            React.createElement("button", { className: classNames(styles.tab, styles[size], {
                    [styles.active]: isActive(tab.id),
                    [styles.disabled]: tabs.slice(0, index).some((t) => !t.completed),
                }), disabled: tabs.slice(0, index).some((t) => !t.completed), onClick: () => handleOnClick(tab.id) },
                tab.completed && !tab.error ? (React.createElement("span", { className: styles.completed },
                    React.createElement(CheckIcon, null))) : (React.createElement("p", { className: styles.number }, index + 1)),
                React.createElement("p", { className: styles.label }, tab.label)),
            index < tabs.length - 1 && (React.createElement("div", { className: classNames(styles.connector, {
                    [styles.hidden]: isActive(tab.id) || isActive((_a = tabs[index + 1]) === null || _a === void 0 ? void 0 : _a.id),
                }) }))));
    })));
};
export default TabsWizard;
